<ng-template #template>
  <div class="container">
    <div class="row px-0 py-5" style="min-height: 800px">
      <div class="p-lg-0 col-lg-12">
        <div class="card h-100">
          <div class="card-body table-responsive-md">
            <h3 style="margin-bottom: 0; margin-top: 15px">
              <span>{{ data?.texts.tableTitleText }}</span>
            </h3>
            <div>
              <table class="table big-table">
                <thead>
                  <tr>
                    <th scope="col-3" style="width: 40%" class="border-0">
                      {{ data?.texts.fileNameText }}
                    </th>
                    <th scope="col-3" style="width: 40%" class="border-0">
                      {{ data?.texts.captionText }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let doc of data?.documents" class="tablestyle">
                    <th scope="row">
                      <button
                        type="button"
                        (click)="opendocument(doc.documentId)"
                        style="border: none; background: none; padding: 0;"
                      >
                        {{ doc.fileName }}
                      </button>
                    </th>

                    <td>
                      <a>{{ doc.caption }}</a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <h3 style="margin-bottom: 0; margin-top: 15px">
              <span>{{ data?.texts.table2TitleText }}</span>
            </h3>
            <div>
              <table class="table big-table">
                <tbody>
                  <tr *ngFor="let doc of data?.videos" class="tablestyle">
                    <td>
                      <div>{{ doc.title }}</div>
                      <div
                        style="
                          margin-top: 25px;
                          margin-bottom: 25px;
                          text-align: center;
                          width: 100%;
                        "
                      >
                        <div class="video-container">
                          <iframe
                            width="853"
                            height="480"
                            [src]="doc.url | safe"
                            frameborder="0"
                            allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                          >
                          </iframe>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
